var Migration, PrognosticOutcomesQualityBaseScore, W,
  __hasProp = {}.hasOwnProperty,
  __extends = function(child, parent) { for (var key in parent) { if (__hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; };

Migration = require('./migration');

W = require('when');

module.exports = PrognosticOutcomesQualityBaseScore = (function(_super) {
  __extends(PrognosticOutcomesQualityBaseScore, _super);

  function PrognosticOutcomesQualityBaseScore() {
    PrognosticOutcomesQualityBaseScore.__super__.constructor.call(this, false);
  }

  PrognosticOutcomesQualityBaseScore.prototype.up = function(project, colls) {
    var outcome, outcomes, question;
    PrognosticOutcomesQualityBaseScore.__super__.up.apply(this, arguments);
    return W.all((function() {
      var _i, _j, _len, _len1, _ref, _results;
      _ref = colls.prognosticQuestions.models;
      _results = [];
      for (_i = 0, _len = _ref.length; _i < _len; _i++) {
        question = _ref[_i];
        outcomes = question.get('outcomes').models;
        for (_j = 0, _len1 = outcomes.length; _j < _len1; _j++) {
          outcome = outcomes[_j];
          outcome.updateQuality();
        }
        _results.push(question.save());
      }
      return _results;
    })())["catch"](function(err) {
      console.log(err);
      throw err;
    });
  };

  return PrognosticOutcomesQualityBaseScore;

})(Migration);
